import { Injectable } from '@angular/core';
import * as keyGen from 'keygenerator';

const KEY_LENGTH = 50;

@Injectable({
  providedIn: 'root',
})
export class KeyGenerationService {
  constructor() {}

  generateKey() {
    return keyGen._({
      length: KEY_LENGTH,
    });
  }
}
